import { Badge } from "@/components/ui/badge";

import type { IrtVerdict } from "./api";
import { irtCell, irtRows } from "./format";

/**
 * The IRT verdict on a table row (C2 v1.7 call I): NEW ISSUE as a word on a badge, never a colour alone, and the
 * covering or created issue as a link to its page. `via` names a verdict read from another row.
 */
export function IrtCell({ verdict, via, createFailed }: { verdict: IrtVerdict | undefined; via?: string; createFailed?: boolean }) {
  const cell = irtCell(verdict, { createFailed });
  if (!cell.badge && !cell.text) return null;
  const text = cell.text && via ? `${via} · ${cell.text}` : cell.text;
  return (
    <span className="block">
      {cell.badge ? <Badge variant="destructive">NEW ISSUE</Badge> : null}
      {text && cell.url ? (
        <a href={cell.url} target="_blank" rel="noreferrer" className="block text-xs text-ks-ink underline-offset-2 hover:underline">{text}</a>
      ) : text ? <span className="block text-xs text-muted-foreground">{text}</span> : null}
    </span>
  );
}

/** The sheet's IRT block: the check in words, the issue's title and STATUS, whether this run created it, the link. */
export function IrtRows({ verdict, via, createFailed }: { verdict: IrtVerdict | undefined; via?: string; createFailed?: boolean }) {
  const rows = irtRows(verdict, via, { createFailed });
  if (!rows.length) return null;
  return (
    <div className="mt-3">
      <p className="text-sm font-medium text-ks-ink">IRT</p>
      <dl>
        {rows.map(([label, value]) => (
          <div key={label} className="flex justify-between gap-4 py-1 text-sm">
            <dt className="text-muted-foreground">{label}</dt>
            <dd className="text-right text-ks-ink">{value}</dd>
          </div>
        ))}
      </dl>
      {verdict?.url ? (
        <a href={verdict.url} target="_blank" rel="noreferrer" className="text-sm text-ks-ink underline-offset-2 hover:underline">open the IRT issue</a>
      ) : null}
    </div>
  );
}
